import React from 'react'
import { useEthers } from '../../hooks'
import { getApprovePairForDelayTx } from '../../transactions'
import { Pair } from '../../model'
import { ApprovalButton } from './ApprovalButton'
import styled from 'styled-components'

interface Props {
  pair: Pair
}

export function LiquidityApprovalButton({ pair }: Props) {
  const { chainId } = useEthers()

  return (
    <Content>
      <ApprovalButton
        symbol={`${pair.getToken0Symbol()}-${pair.getToken1Symbol()}`}
        transaction={chainId && getApprovePairForDelayTx(pair, chainId)}
      />
    </Content>
  )
}

const Content = styled.div`
  margin-bottom: 12px;
  padding: 0 20px;
`
